// src/features/projects/ProjectHealthRing.jsx
//
// PROJECTS-HEALTH-SOLID-DOT: Canonical solid filled 10px dot for the
// Projects list Health column. Replaces the previous hollow ring (option C).
// Matches option A from the approved comp — same tokens as HealthDot but no
// glow, no box-shadow, no border. Location cards and Location detail continue
// to use HealthDot.

import React from "react";
import { HEALTH, T } from "../../app/tokens.js";

export function ProjectHealthRing({ health }) {
  const color = health ? (HEALTH[health]?.color ?? T.defaultDot) : T.defaultDot;
  const label = health ? (HEALTH[health]?.label ?? health) : null;

  return (
    <div
      title={label ? `Health: ${label}` : "No health data"}
      style={{
        width: 10,
        height: 10,
        borderRadius: "50%",
        background: color,
        flexShrink: 0,
        display: "inline-block",
      }}
    />
  );
}
